import { createContext } from '@/utils';

export type VisitorContextValue = {
  isCollaboratorView: boolean;
  setIsCollaboratorView: (isCollaboratorView: boolean) => void;
};

export const VisitorContext = createContext<VisitorContextValue | undefined>(
  undefined,
  'VisitorContext'
);
